// extracted by mini-css-extract-plugin
export default {"header":"r03QHz","backButton":"kA5eYs","searchInputContainer":"oVF87n","input":"O36ky9","icon":"lKFybJ"};